import { useEffect, useState } from 'react';
import { getMandatorDetails } from 'services/core-data';
import { IMandatorDetails } from 'types';

interface IMandatorDataHookOptions {
  readonly mandatorId?: string;
}

export function useMandatorData(options: IMandatorDataHookOptions) {
  const [mandatorData, setMandatorData] = useState<IMandatorDetails>();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<unknown>();

  useEffect(() => {
    if (options.mandatorId === undefined) {
      return;
    }

    setLoading(true);
    getMandatorDetails(options.mandatorId)
      .then(data => {
        setMandatorData(data);
        setError(undefined);
      })
      .catch(err => {
        setMandatorData(undefined);
        setError(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [options.mandatorId]);

  return {
    mandatorData,
    mandatorDataError: error,
    mandatorDataLoading: loading
  };
}
